import React from "react";

const quotes = [
  { q: "I finally feel like I have a place to put it all down.", a: "M., 32" },
  { q: "It’s the first room I’ve ever cried in without apologising.", a: "J., 41" },
  { q: "Six months in and I am unrecognisable to myself — in the best way.", a: "S., 28" },
  { q: "They didn’t fix me. They reminded me I wasn’t broken.", a: "A., 36" },
  { q: "The most thoughtful, unhurried care I have ever received.", a: "R., 49" },
];

export default function Testimonials() {
  // duplicate for marquee
  const list = [...quotes, ...quotes];
  return (
    <section className="relative py-24 md:py-32 bg-[#FDFBF7] overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-12">
        <p className="overline text-[#9F5C45] mb-6">04 — In their words</p>
        <h2 className="font-serif font-light text-[#1C1917] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-3xl">
          Real letters, <em className="italic text-[#3A5A40]">real people.</em>
        </h2>
      </div>

      <div className="relative">
        <div className="flex marquee-track gap-16 whitespace-nowrap">
          {list.map((t, i) => (
            <div key={i} className="inline-flex items-start gap-8 max-w-[640px] whitespace-normal" data-testid={`testimonial-${i}`}>
              <span className="font-serif italic text-[#9F5C45] text-6xl leading-none">“</span>
              <div className="flex-1">
                <p className="font-serif italic text-[#1C1917] text-2xl md:text-3xl leading-snug">
                  {t.q}
                </p>
                <p className="overline text-[#57534E] mt-4">— {t.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
